import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles, Paper, Typography } from '@material-ui/core';
import PageContainer from 'components/@layout/PageContainer';
import AppBar from 'components/@layout/Unauthenticated/AppBar';
import useUiStore from 'store/ui';
import { ModuleProps } from 'types';
import { AlertVariant } from 'types/enums';
import Logo from '../../assets/lwt_logo-black.svg';
import BulkImportUploadForm from './components/BulkImportUploadForm';

const BulkImportUploadModule = (props: ModuleProps) => {
  const classes = useStyles();
  const { t } = useTranslation('BulkImportUploadForm');
  const [, { openAlert }] = useUiStore();

  const handleError = () =>
    openAlert({
      variant: AlertVariant.WARNING,
      titleText: t('errorTitle'),
      html:
        /* prettier-ignore */
        <Trans t={t} i18nKey="errorText">
          Please try again or contact <a href="mailto:implementation@lwtears.com">implementation@lwtears.com</a> if the problem persists.
        </Trans>,
      heightAuto: false,
      showCancelButton: false
    });

  const handleSuccess = () =>
    openAlert({
      variant: AlertVariant.SUCCESS,
      titleText: t('successTitle'),
      text: t('successText'),
      heightAuto: false,
      onClose: () => {
        // TODO: Hacky way to reset form because Formik, reCAPTCHA, and file input refs causing headaches.
        const uploadForm = document.getElementById('upload_form');
        if (uploadForm) (uploadForm as HTMLFormElement).reset();
      }
    });

  return (
    <PageContainer>
      <AppBar {...props} className={classes.header}>
        <img src={Logo} alt="Learning without Tears Logo" className={classes.logo} />
        <Typography variant="h1">{t('secureUpload')}</Typography>
      </AppBar>
      <Paper elevation={2} className={classes.formContainer}>
        <BulkImportUploadForm onError={handleError} onSuccess={handleSuccess} />
      </Paper>
    </PageContainer>
  );
};

const useStyles = makeStyles(theme => ({
  header: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: `${theme.spacing(4)}px`
  },
  formContainer: {
    padding: theme.spacing(3),
    margin: `${theme.spacing(3)}px auto`,
    maxWidth: 600
  },
  logo: {
    height: 70
  }
}));

export default BulkImportUploadModule;
